import gql from 'graphql-tag';

export const GET_GIFTY = gql`
  query getGifty {
    gifty {
      locations {
        id
        address
      }
      locationMappings {
        locationId
        giftyLocationId
      }
    }
  }
`;

export const CREATE_GIFTY_APP = gql`
  mutation createGiftyApp($input: CreateGiftyAppInput!) {
    createGiftyApp(input: $input) {
      giftyApp {
        id
      }
      errors {
        message
        type
      }
    }
  }
`;

export const UPDATE_GIFTY_LOCATIONS = gql`
  mutation updateGiftyLocations($input: UpdateGiftyLocationsInput!) {
    updateGiftyLocations(input: $input) {
      giftyApp {
        id
      }
      errors {
        message
        type
      }
    }
  }
`;
